export default "__VITE_ASSET__BSLwakyA__"